/**
 * @module Widget
 */

import { Component, Input } from '@angular/core';
import { WidgetLayersClass } from '@class/widgetLayers.class';
import { UID } from '@models/uid.model';
import { ItemColor } from '@functions/item.functions';

@Component({
  selector: 'app-widget-layers-percent',
  templateUrl: './widget-layers-percent.component.html',
  styleUrls: ['./widget-layers-percent.component.css']
})
export class WidgetLayersPercentComponent {

  @Input() widgetLayers: WidgetLayersClass;
  @Input() current: UID;

  color = ItemColor('widgets');

  constructor() {}

  receiveValue(value: boolean) {
    this.widgetLayers.layer(this.current).change({ gaugePercent: value });
    if(this.widgetLayers.uid.value === this.current) this.widgetLayers.duplicateLayersOptions({ gaugePercent: value }, this.current);
  }

}
